module.exports = {
	"contract_name": "CredentialsStore",
	"abi": [
		{
			"constant": true,
			"inputs": [
				{
					"name": "credentialId",
					"type": "uint256"
				}
			],
			"name": "find",
			"outputs": [
				{
					"name": "issuer",
					"type": "bytes32"
				},
				{
					"name": "recipient",
					"type": "bytes32"
				},
				{
					"name": "status",
					"type": "bytes32"
				},
				{
					"name": "imageHash",
					"type": "bytes"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "status",
					"type": "bytes32"
				}
			],
			"name": "getCredentialsByStatusCount",
			"outputs": [
				{
					"name": "count",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "issuer",
					"type": "bytes32"
				},
				{
					"name": "recipient",
					"type": "bytes32"
				},
				{
					"name": "status",
					"type": "bytes32"
				},
				{
					"name": "imageHash",
					"type": "bytes"
				}
			],
			"name": "save",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "status",
					"type": "bytes32"
				},
				{
					"name": "i",
					"type": "uint256"
				}
			],
			"name": "getCredentialIdByStatus",
			"outputs": [
				{
					"name": "credentialId",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "bytes32"
				},
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "credentialIdsByStatus",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "credentials",
			"outputs": [
				{
					"name": "sender",
					"type": "address"
				},
				{
					"name": "issuer",
					"type": "bytes32"
				},
				{
					"name": "recipient",
					"type": "bytes32"
				},
				{
					"name": "status",
					"type": "bytes32"
				},
				{
					"name": "imageHash",
					"type": "bytes"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "lastCredentialId",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"inputs": [],
			"payable": false,
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "_sender",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_credentialId",
					"type": "uint256"
				}
			],
			"name": "NewCredentialStored",
			"type": "event"
		}
	],
	"unlinked_binary": "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",
	"networks": {
		"4": {
			"events": {
				"0xeb6375c5a94a373cbda30a2313b0c135dad3c067f708715198f242a4efc686fc": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "_sender",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "_credentialId",
							"type": "uint256"
						}
					],
					"name": "NewCredentialStored",
					"type": "event"
				}
			},
			"links": {},
			"address": "0x9b19915e54a0d133a849b1d796ec6494aed3e6e2",
			"updated_at": 1507934065672
		}
	},
	"schema_version": "0.0.5",
	"updated_at": 1507934065672
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/CredentialsStore.json
// module id = 196
// module chunks = 0